import React, { useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { isUsersnapActive } from "@labxchange/util-usersnap";
import { Button } from "@learningblocks/shared-components/lib/Button";

import { default as i18n } from "@learningblocks/shared-components/lib/i18n";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

import className from "../style.module.scss";

export function IntroModal(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const [imgSrc, setImgSrc] = useState();

  useEffect(() => {
    if (props.introGraphic) {
      setImgSrc(
        window.location.origin +
          window.location.pathname +
          `locales/${i18n.language}/images/${props.introGraphic.src}`
      );
    }
  }, []);

  return (
    <FocusLock disabled={isUsersnapActive() || !props.standalone}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={`IntroModalIntro_`}
        aria-describedby={`IntroModalIntro_`}
        className={`${className.IntroModalContainer}`}
      >
        <div className={className.IntroModalWrapper}>
          <div className={className.IntroModal}>
            {props.includeGraphic && (
              <img
                className={className.introImg}
                src={imgSrc}
                alt={
                  props.introGraphic
                    ? t(`${props.introGraphic.altText}.string`)
                    : ""
                }
                onError={() => {
                  setImgSrc(
                    window.location.origin +
                      window.location.pathname +
                      `locales/en/images/${props.introGraphic.src}`
                  );
                }}
              />
            )}
            <div id={`IntroModalIntro_`} className={className.IntroModalIntro}>
              {parse(t(`${props.text}.string`))}
            </div>
            <Button
              type="primary"
              className={className.StartBtn}
              tabIndex={0}
              onClick={() => {
                props.closeIntroModal();
              }}
            >
              {props.firstIntro
                ? parse(t("begin.string"))
                : parse(t("close.string"))}
            </Button>
          </div>
        </div>
      </div>
    </FocusLock>
  );
}
